export default {
    global: {
        alert: {
            session_expired_title: `Session Expired`,
            session_expired_subtitle: `Sorry, your session has expired. Please login again.`,
            staging_alert_msg: `Warning`,
            staging_alert_desc: `Please be aware this is an test environment. Please DO NOT make any deposit or trading to avoid any loss.`,
        },
        menu: {
            home: "Home",
            features: "Features",
            privacy: "Privacy",
            term_of_use: "Term of Use",
            buy_sell: "Buy/Sell",
            contact_us: "Contact Us",
            faq: "FAQs",
            dashboard: "Dashboard",
            my_profile: "My Profile",
            deposits: "Deposits",
            withdrawals: "Withdrawals",
            referral: "Referral",
            history: "History",
            security: "Security",
            support: "Support",
            complete_kyc: "Complete KYC",
            make_withdrawals: "Make Withdrawals",
            manage_crypto_addresses: "Manage Crypto Addresses",
            manage_bank_accounts: "Manage Bank Accounts",
            update_password: "Update Password",
            update_2fa: "Update 2FA",
            developer_api: "Developer API",
            merchant_sub_accounts: "Merchant Sub Accounts",
            warning_id_not_verified: "Identify not verified!",
            btn_sign_up: "Sign up",
            btn_sign_in: "Sign in",
            btn_sign_off: "Sign off",
            confirm_logout_title: "Are you sure to logout?",
            confirm_ok: "Yes",
            confirm_cancel: "No",
        },
        risk_banner: {
            headline: `Risk Reminder :`,
            description_before_not: `OTCPro is an independent AUSTRAC-registered cryptocurrency exchange and does `,
            description_not: `NOT`,
            description_after_not: ` partner with third parties, agents, investment schemes, or recovery services. Never transfer funds to anyone claiming to represent OTCPro outside our official channels.`,
            contact_us: `Contact Us`,
            close: `Close risk reminder`,
        },
        deposit_pending_banner: {
            description_before: `Your deposit is `,
            status: `PENDING`,
            description_after: ` for more information, please provide sender details to ensure timely processing. This only takes a minute. `,
            cta: `Resolve Now`,
        }
    },
    home: {
        banner: {
            introducing: `Introducing`,
            title: `Electronic Pricing`,
            desc: `Your crypto trades just got simpler and smarter`,
            signup: `Sign Up`
        },
        price: {
            title: `Assets you can trade us with`,
            desc: `With more to come, tell us what coins you want to trade!`,
            buy_price: `Buy Price`,
            sell_price: `Sell Price`,
            aud: `AUD`,
            usd: `USD`,
            others: `Others`,
        },
        feature: {
            title: `TOP FEATURES`,
            desc: `That sets us apart from the ordinary`,
            steaming_price: `Streaming Price`,
            steaming_price_desc: `Monitor live prices in defined quantities and settle in one click.`,
            no_fee: `No Fees`,
            no_fee_desc: `Fees are in the past. Save your calculation, what you see is what you get.`,
            deep_liquidity: `Deep Liquidity`,
            deep_liquidity_desc: `Execute your large orders without moving the market too much.`,
            compliant: `Compliant`,
            compliant_desc: `AUSTRAC registered platform. Our comprehensive compliance programs ensure your funds are always safe and secure.`,
            future_Release: `Future Release`,
            lock_price: `Lock price before sending fund and settle in 24h.`,
            set_limit: `Set limit orders when you expect a better execution price.`,
        },
        who_we_are: {
            title: `Who We Are`,
            sub_title: `A Team of Experts`,
            dsec: `We are a team with 5+ years crypto program trading experience, who has successfully supported liquidity of leading exchanges. Now we bring streaming price to OTC market, help you to manage your trade in one click.`
        },
        faqs: {
            title: `FAQs`,
            what_is_otcpro: {
                title: `What is OTCPro`,
                desc: `OTCPro is a streaming priced cryptocurrency OTC trading platform, allow buyers and sellers to get live quote at defined quantities, and execute at one click.`
            },
            deposits: {
                title: `Deposits`,
                crypto_deposits: {
                    title: `Crypto deposits`,
                    desc: `Every customer of OTCPro will be given a unique wallet address to receive cryptos. You may find your wallet address in the Dashboard screen by click ‘deposit’ and then select the currency you wish to deposit. `
                },
                deposit_not_arrived: {
                    title: `Deposit not arrived`,
                    desc: `Firstly, make sure you send to the correct wallet address, then check the transaction status on blockchain with your transaction hash, different assets take different confirmations to be fully confirmed and credited to your account. If you still have questions about your deposits, please reach out to customer support.`
                },
                fiat_deposits: {
                    title: `Fiat deposits`,
                    desc: `OTCPro encourages Australia local customers to use PayID method to deposit AUD. Making deposit via PayID is free and fast. If you are out of Australia or unable to use PayID, we also provide BSB & Account number to receive fiat deposit. No matter what method you choose, please make sure your bank account matches the name registered with OTCPro. Any third-party deposits will be hold and flag your account to review.`
                },
                how_long_does_it_take: {
                    title: `How long does it take`,
                    desc: `PayID deposit is usually instant, but the fist deposit may take up to 24hrs. Bank transfer usually takes 1-3 business day.`
                },
            },
            withdrawals: {
                title: `Withdrawals`,
                how_long_does_it_take: {
                    title: `How long does it take`,
                    desc: `Withdrawals of your fiat and cryptos usually will be processed within 48 hours, but delays happen due to service provider and banking interruption. `
                },
                withdrawal_limit: {
                    title: `Withdrawal limit`,
                    desc: `You can view your daily withdrawal limit on the dashboard. Every user will be given $100,000 USD daily withdrawal limit to start from, this limit is shared by fiat and crypto currency. Your can increase the limit by submitting a request to our support team, your request will be reviewed based on your trading volume, risk level, etc. `
                },
            },
            trading: {
                title: `Trading`,
                desc: `Our streaming-priced trading system allows user to monitor live price in user-defined quantities and execute in one click. Simply type in your desired quantity of cryptos, the quotes will adjusted accordingly, select the direction of your trade (Buy/ Sell), then deal. `,
                secure_price_inadvance: {
                    title: `Secure price in advance`,
                    desc: `This function allows user to enter a trade without having the full value of the trade. To secure price in advance for a trade, you need to:`,
                    sub_1: `Hold a balance in your account, either in fiat or digital currencies, of at least the pre-determined amount we set based on your risk level`,
                    sub_2: `Settle your trades within 24 hours of you placing the trade. Late settlement will incur fees at a daily rate of 0.1% over the outstanding amount.`,
                    paragraph: `You can send a request to our customer support to enable this feature. We need to evaluate your financials, trading records and risk level to decide the risk exposure limit to your account(the maximum overdraft amount you can use for trading). In the meantime, you need to maintain a minimum margin requirement (the deposit you need to keep in your account when perform “secure price in advance” trades).`
                },
            },
            referral: {
                title: `Referral`,
                desc: `Invite your friend and get 0.05% commission of their trading volumes. Referral commission is calculated and released to your account at the end of each month. It will directly credit to your AUD balance.`
            },
            fees: {
                title: `Fees`,
                list_1: `Trading: there is no trading fees or exchange fees`,
                list_2: `Deposits: There is no charge on deposits to the platform, both for fiat and cryptos. We will reflect the exact amount received on our side to your platform account`,
                list_3: `Withdrawals: No fees for Australia local AUD withdrawal, however, some fees might be incurred on abnormal occasions, including:
                Rejected fiat withdrawals: $5.00 each local transaction, which will be deducted from your OTCPro account balance after the funds bounce back
                International fiat withdrawals: $30.00 - $50.00 transfer fee, depending on the currency and payment service provider charge. It will be deducted from your withdrawal amount. `,
                list_4: `Late settlement fee: when under “secure price in advance” mode, interest will be charged on the outstanding sum at a daily rate of 0.1% if the transaction is not settled within 24 hours.`,
                list_5: `Any extra fees caused by users will be at the customer’s expense.`,
            },
            account_security: {
                title: `Account Security`,
                desc: `OTCPro uses the Google Authenticator application to provide two-factor authentication. Two-factor authentication is a one-time code generated from your Google Authenticator mobile application, to give your account an additional layer of security. We strongly encourage our customers to enable 2FA to protect the safety of your account.`
            },
            prohibited_jurisdictions: {
                title: `Prohibited Jurisdictions`,
                desc: `We will not provide our services to Clients based in the following jurisdictions:`,
                list_1: `United State of America;`,
                list_2: `High risk jurisdictions which include the following:
                Afghanistan, Botswana, Burundi, Cameroon, Chad, The Democratic Republic of the Congo, Cote D'Ivoire, Cuba, Eritrea, Gambia, Ghana, Guinea, Haiti, Iran, Iraq, North Korea, Kyrgyzstan, Lebanon, Lesotho, Liberia, Libyan Arab Jamahirya, Mali, Myanmar, Niger, Somalia, Sudan, Syria, Uganda, Yemen, Zimbabwe`,
                list_3: `Medium risk jurisdiction which include the following:
                Angola, Bangladesh, Bahrain, Belarus, Bolivia, Burkina Faso, Cambodia, China, Central African Republic, Colombia, Comoros, Ecuador, Egypt, Equatorial Guinea, Ethiopia, Georgia, Greenland, Guatemala, Guinea-Bissau, Holy See (Vatican City State), India, Indonesia, Israel, Jordan, Kazakhstan, Kenya, Kuwait, Lao People's Democratic Republic, Madagascar, Malawi, Mauritania, Nigeria, Oman, Pakistan, Palestine, Papua New Guinea, Peru, Philippines, Russian Federation, Qatar, Rwanda, Sao Tome and Principe, Saudi Arabia, Sierra Leone, Solomon Islands, Sri Lanka, South Africa, Tajikistan, Timor-Leste, Togo, Turkey, Turkmenistan, United Arab Emirates, Uzbekistan, Venezuela, Vietnam, Zambia`
            },
        },
        get_in_touch: {
            title: `Get In Touch`,
            sub_title_1: `General Enquiries`,
            sub_title_2: `Submit a Request`,
            name: `Name`,
            email: `Email`,
            message: `Message`,
            btn: `Send`
        },
        ribbon: {
            title: `Get Your Trading Started Today!`,
            btn: `Sign Up`
        },
    },
    contact_us: {
        title: `Contact Support`,
        subtitle_1: `Our support team is available Monday to Friday, 9:00am – 5:30pm AET.`,
        subtitle_2: `We'll respond to your enquiry as soon as possible.`,
        name: `Name`,
        email: `Register Email`,
        guest_email: `Email`,
        topic: `Topic`,
        message: `Message`,
        name_placeholder: `Name`,
        email_placeholder: `Email`,
        topic_placeholder: `Select the reason for your enquiry`,
        message_placeholder: `Please describe your enquiry and include any relevant transaction IDs, wallet addresses, or screenshots if applicable.`,
        name_required: `Please provide your name.`,
        email_invalid: `Invalid email address`,
        topic_required: `Please select a topic.`,
        message_required: `Message is required`,
        send_message: `Send Message`,
        submit_success: `Your inquiry has been submitted, OTCPro team will back to you as soon as possible.`,
        footer_note: `Identity verification is typically completed within 1 business day. Compliance-related enquiries and reviews may occasionally require additional processing time. Deposits and withdrawals submitted outside banking hours may take longer to process depending on your bank and payment network. Trading on OTCPro is available 24/7.`,
        topics: {
            trade_issue: `Trade Issue`,
            deposit_withdrawal: `Deposit / Withdrawal`,
            kyc_verification: `KYC / Verification Help`,
            account_security: `Account Security`,
            other_inquiry: `Other Inquiry`,
        },
        attach_files: `Attach Files (Optional)`,
        drag_drop: `Drag & Drop your images or documents`,
        browse_hint: `(PNG, JPG, PDF) Or Click To Browse`,
        max_size: `Max 10MB Total`,
        file_size_exceeded: `Total file size cannot exceed 10MB.`,
        invalid_file_type: `Invalid file type. Please upload PNG, JPG, or PDF files only.`,
        upload_failed: `File upload failed. Please try again.`,
    },
    privacy: {
        h1: `Privacy Policy`,
        p1: `Rhino Trading Pty Ltd ACN 655 361 345 with Business name of OTCPro(we or us) is registered with AUSTRAC to provide DCE(DIGITAL CURRENCY EXCHANGE) service, as required by law to take steps to prevent fraud, money-laundering and terrorist-financing. We are committed to protecting your privacy in accordance with the Privacy Act 1988 Cth. The law governs the way in which we may collect, use and disclose personal information about any individual.`,
        h2: `What information do we collect?`,
        p2: `We collect personal information from customers for identity verification purposes. This can include a broad range of information ranging from`,
        list1: {
            l1: `Information about you: your name, address, date of birth, contact details, employment details, Photographic identification, bills,`,
            l2: `Information about your financials and transactions: banking details, account numbers, digital currency account, trading behavioural characteristics and preferences, source of funds, trading purposes`,
            l3: `Information about your browser and device, including IP addresses, browser vendor, device type and size, cookie identifiers`,
        },
        p3: `Where you are a legal entity other than an individual, we may collect below information, including, but not limited to:`,
        list2: {
            l1: `registration and incorporation documents,`,
            l2: `company statement evidencing registered office, ownership structure and directors,`,
            l3: `authorization letters to authorize users responsible for the account,`,
            l4: `qualifications if providing services under regulation,`,
            l5: `other information comply with all relevant laws and regulations.`,
        },
        h3: `Does OTCPro share your personal information?`,
        p4: `We do not sell, trade your information to others. We may disclose your information to third party suppliers and service providers, regulatory bodies, government agencies, law enforcement bodies and courts. We may provide your information to others if we are required to do so by law or under some unusual other circumstances which the Privacy Act permits. However, we will take all reasonable steps to ensure that they protect your information in the same way that we do.`,
        h4: `How do we protect your information?`,
        p5: `We recognise the importance of securing the personal information of our customers. All these data will be allocated in an isolated private network, and we work to protect the security of your personal information during transmission by using encryption protocols and software.`,
        h5: `Accessing your information`,
        p6: `You can obtain a copy of your Personal Information upon request. You can also manage, edit, or update certain personal information on our platform by logging into your OTCPro account. We will also correct, amend or delete any personal information that we agree is inaccurate, irrelevant, out of date or incomplete.`,
        h6: `Amendments to the policy`,
        p7: `We may from time to time vary this Privacy Policy. Please check our website regularly for an up-to-date version of our Privacy Policy.`,
        p8: `Have a thought about our policy?`,
        p9: `If you have any questions, concerns or complaints about our privacy policy, please submit a request from support page or email us at support{'@'}otcpro.io`
    },
    sign_in: {
        title: `Sign In`,
        btn_forgot: `Forgot Password?`,
        btn_sign_up: `Sign Up`,
        btn_login: `Login`,
        email: 'Email',
        password: `Password`,
        msg_2fa: `We've sent a code to your email.`,
        zp_loading: `Authenticating...`,
        zp_auth_failed: `Authentication failed. Please open in Zapry app and try again.`,
        zp_cancelled: `Cancelled`,
    },
    email_verify: {
        title: `Email Verification`,
        label_email: `Email`,
        label_code: `Verification Code`,
        placeholder_email: `Enter your email`,
        placeholder_code: `Enter verification code`,
        btn_confirm: `Confirm`,
        btn_send_code: `Send Code`,
        resend_in: `Resend in {n}s`,
        hint_invalid_email: `Please enter a valid email address`,
        err_enter_email_first: `Please enter your email first`,
        err_enter_email: `Please enter your email`,
        err_enter_code: `Please enter the verification code`,
        success_sent: `Verification code has been sent to your email`,
        success_verified: `Email verified successfully`,
        err_send_failed: `Failed to send. Please try again later.`,
        err_verify_failed: `Verification failed. Please try again.`,
    },
    deposit: {
        quick_recharge: {
            title: `Quick Wallet Deposit`,
            ok_text: `Confirm Deposit`,
            cancel_text: `Cancel`,
            label_amount: `Amount`,
            placeholder_amount: `Enter deposit amount`,
            min_amount: `Minimum deposit`,
            wallet_balance: `Wallet balance`,
            refresh: `Refresh`,
            label_remark: `Remark (optional)`,
            placeholder_remark: `Optional, for your reference`,
            loading_connect: `Connecting wallet and fetching balance…`,
            loading_balance: `Fetching balance…`,
            err_no_wallet: `Please install MetaMask or a WalletConnect-compatible wallet and try again.`,
            err_no_account: `No wallet account found. Please authorize the connection.`,
            err_connect_failed: `Failed to connect wallet or fetch balance.`,
            err_chain_not_configured: `Chain info not configured.`,
            err_invalid_amount: `Please enter a valid deposit amount.`,
            err_below_min: `Amount cannot be less than minimum deposit {min} {asset}`,
            err_exceeds_balance: `Amount cannot exceed wallet balance.`,
            success_submitted: `Deposit submitted. Confirmation is subject to on-chain settlement.`,
            err_tx_failed: `Transaction failed. Please try again.`,
            btn: `Quick Wallet Deposit`,
        },
        crypto_detail: {
            min_deposit: {
                label: `Minimum Deposit:`,
                middle: `Deposits below`,
                after: `will not be credited to your account.`,
            },
            tip: {
                title: `Speed Up Future Crypto Transactions 🚀`,
                description_before: `Add your self-hosted wallet addresses under `,
                description_highlight: `Withdraw → Manage Crypto Addresses`,
                description_after: `. Once verified, future deposits and withdrawals involving those addresses can generally be processed more quickly.`,
                manage_addresses: `Manage Addresses`,
            },
            receiving_network: `RECEIVING NETWORK`,
            destination_wallet_address: `DESTINATION WALLET ADDRESS`,
        },
        details_flow: {
            banner: {
                title: `Complete your deposit details`,
                description: `Your deposit is pending for more information, please provide sender details to ensure timely processing. `,
                highlight: `This only takes a minute.`,
                cta: `Complete Now`,
            },
            common: {
                close: `Close`,
                back: `Back`,
                submit: `Submit`,
                review_confirm: `Review & Confirm`,
                copy_success: `Deposit address copied.`,
                copy_failed: `Copy failed, please copy manually.`,
                deposit_count: `{count} deposits from this wallet`,
                items_count: `{count} Items`,
                enter_value: `Enter {value}`,
                options: {
                    other: `Other`,
                    others: `Others`,
                    low_risk_countries: `Those Countries in low risk list`,
                    family_member: `Family member`,
                    friend: `Friend`,
                    business_partner: `Business partner`,
                    client_customer: `Client/Customer`,
                    client_customer_spaced: `Client / Customer`,
                    personal_transfer: `Personal transfer (gift, support)`,
                    payment_for_goods_or_services: `Payment for goods or services`,
                    loan_or_repayment: `Loan or repayment`,
                    business_transaction: `Business transaction`,
                    employer: `Employer`,
                    company_i_own_or_control: `Company I own or control`,
                    service_provider: `Service provider`,
                    salary_income: `Salary / income`,
                    investment_funding: `Investment / funding`,
                },
            },
            action_modal: {
                title: `Additional Information required`,
                description: `To meet updated regulatory requirements, we need a few details about your deposit.`,
                summary: `{count} addresses require your action`,
                deposit_count: `{count} deposits`,
                received_on: `Received on {timestamp}`,
                review_cta: `Complete Now`,
            },
            review_modal: {
                title: `Complete Deposit Information`,
                description: `Please provide information about the sender of this deposit.`,
                deposit_source_address: `Deposit Source Address`,
                deposit_transactions_count: `{count} deposit transactions`,
                sender_type: {
                    title: `Who is sending the crypto?`,
                    myself: `Myself (self-hosted wallet/VASP)`,
                    others: `Others`,
                },
                account_owner: {
                    title: `Who owns the account that sent these funds?`,
                    subtitle: `This is the person or organisation that the sending wallet or account belongs to.`,
                    individual: {
                        label: `Individual`,
                        help: `A person sending funds to you`,
                    },
                    business: {
                        label: `Business/Company`,
                        help: `A company or organisation`,
                    },
                },
                individual: {
                    sender_name: {
                        label: `Full Name of the Sender`,
                        placeholder: `Enter the full name...`,
                    },
                    person_base: {
                        label: `Where the person is based`,
                        placeholder: `Select where the person is based`,
                        other_placeholder: `Enter the location`,
                    },
                    relationship: {
                        label: `Your relationship with the account owner`,
                        placeholder: `Select your relationship`,
                        other_placeholder: `Enter the relationship`,
                    },
                    transfer_purpose: {
                        placeholder: `Select the transfer purpose`,
                    },
                },
                business: {
                    company_name: {
                        label: `Company Name`,
                        placeholder: `Enter the full name...`,
                    },
                    country: {
                        label: `Country of the Company`,
                        placeholder: `Select the country of the company`,
                        other_placeholder: `Enter the country of the company`,
                    },
                    relationship: {
                        label: `Your relationship to this entity`,
                        placeholder: `Select your relationship to this entity`,
                        other_placeholder: `Enter your relationship to this entity`,
                    },
                    transfer_purpose: {
                        placeholder: `Select the purpose of this transfer`,
                    },
                },
                transfer_purpose: {
                    label: `What is the purpose of this transfer?`,
                    help: `Select the main reason for this transfer`,
                    other_placeholder: `Enter the transfer purpose`,
                },
                wallet_type: {
                    title: `Is this address from your private wallet, or from an VASP?`,
                    self_hosted: {
                        label: `Self-hosted Wallet`,
                        help: `A personal wallet where you control the private keys (e.g. MetaMask, Ledger)`,
                    },
                    vasp: {
                        label: `Virtual Asset Service Provider`,
                        help: `An exchange account registered in your name (e.g. Binance, Coinbase)`,
                    },
                },
                wallet_application_name: {
                    label: `Wallet application name`,
                    placeholder: `Wallet application name`,
                },
                vasp: {
                    platform_name: {
                        label: `Platform Name`,
                        placeholder: `Select platform`,
                        other_placeholder: `Enter the platform name`,
                    },
                    exchange_location: {
                        label: `Where is this Exchange`,
                        placeholder: `Select exchange location`,
                        other_placeholder: `Enter the exchange location`,
                    },
                    account_identifier: {
                        label: `Account Identifier`,
                        placeholder: `Select type`,
                        value_placeholder: `Enter account identifier value`,
                    },
                },
                    confirm_checkbox: `I confirm this wallet address is owned and controlled by me`,
                    confirm_checkbox_help: `Control means that only you have access to the wallet’s private key or recovery phrase.`,
            },
            submit_success: `Deposit information for {address} has been submitted.`,
        },
    },
    sign_up: {
        title: `Sign Up`,
        btn_login: `Already have a account? Login`,
        email: 'Email',
        password: `Password`,
        password_repeat: `Repeat Password`,
        referral_code: `Referral Code (Optional)`,
        btn_submit: `Submit`,
    },
    sign_up_success: {
        title: "Welcome to OTCPRO",
        sub_title: "Thanks for signing up to OTCPRO.",
        p1: "Before you can login with your account, we have send you a verification email.",
        p2: "Please follow the instrucation and link to activate your account.",
        btn: "Sign in"
    },
    trade: {
        operation_completed: `Operation completed`,
        operation_failed: `Operation failed`,
    },
    withdraw: {
        form: {
            official_site: `Official site: {domain}`,
            security_notice: `OTCPro will never ask you to pay a collateral deposit, verification fee, or prepayment to unlock withdrawals. If you see such a message, close this page and contact us through {domain} only.`,
            tamper_alert_title: `Security warning`,
            tamper_alert_description: `The withdrawal information below may have been modified by an untrusted source (such as a browser extension). Do not transfer any funds. Use incognito mode with extensions disabled, or contact support via our official website.`,
            tips: {
                aud: {
                    local_fee: `Local AUD withdrawal above $10,000 is free, under $10,000 will incur $3 small transfer fee.`,
                    international_fee: `International AUD withdrawal has $50 transfer fee, which will be deducted from your withdraw amount.`,
                    bank_details: `Incorrect bank details will lead to significant delays and fees incur for rejected withdrawals.`,
                },
                usd: {
                    transfer_fee: `Transfer fee: 50USD, will be deducted from your withdrawal amount`,
                    small_withdrawal_fee: `Small withdrawal fee of 100USD applies to all withdrawals under $50,000 (on top of transfer fee)`,
                    bank_details: `Incorrect bank details will lead to significant delays and fees incur for rejected funds`,
                },
                token: {
                    wrong_network: `Cryptos sent to the wrong network or address are not recoverable.`,
                    own_wallet: `Please link your own wallet address for crypto settlement.`,
                },
            },
        },
        email_verify: {
            description: `Enter the 6 digit code sent to your email.`,
            get_code: `Get Code`,
            resend_code: `Resend code`,
        },
        two_fa_verify: {
            description: `Enter the 6-digit code from your authenticator app.`,
        },
        token_address_book: {
            entry: {
                title: `Manage Crypto Addresses`,
                description: `Add and review the wallet addresses you use for crypto withdrawals.`,
                button_title: `Continue to Verification`,
                button_subtitle: `Create a new withdrawal address`,
            },
            list: {
                title: `Address List`,
                columns: {
                    token: `Token`,
                    chain: `Chain`,
                    memo: `MEMO`,
                    address: `Address`,
                    nickname: `Nickname`,
                    status: `Status`,
                },
                confirm: {
                    title: `Would you like to delete this address?`,
                    description: `You won't be able to reverse the action, you will have to re-add the address manually.`,
                    ok: `Yes`,
                    cancel: `No`,
                },
                delete: `Delete`,
                deleted: `Token address has been deleted.`,
                copy_address: `Copy address`,
                copy_success: `Address copied.`,
                copy_failed: `Unable to copy address.`,
                status_verified_note: `This address has been successfully verified and is ready to use for withdrawals.`,
            },
            modal: {
                title: `Add a New Address`,
                description: `Enter the wallet details you want to use for crypto withdrawals.`,
            },
            modal_unavailable: {
                title: `Address Not Available`,
                description: `This address can’t be added. Please enter a different wallet address`,
            },
            form: {
                title: `Add New Crypto Address`,
                description: `Enter the wallet details you want to use for crypto withdrawals.`,
                token: `Token`,
                token_placeholder: `Choose token`,
                network: `Network`,
                network_placeholder: `Choose network`,
                address: `Address`,
                address_placeholder: `Enter the wallet address...`,
                address_tip_title: `Make sure this wallet address belongs to you.`,
                address_tip_description: `We only support withdrawals to wallet addresses under your control.`,
                destination_tag: `Memo (Destination Tag)`,
                destination_tag_placeholder: `Enter destination tag`,
                nickname: `Nickname`,
                nickname_placeholder: `Give a Nickname of this wallet...`,
                token_address: `Address`,
                success_title: `Crypto Address added successfully`,
                success_description: `Multi-line snackbar with longer body context, Multi-line snackbar with longer body context`,
                unavailable_title: `This address is already linked to another account`,
                unavailable_description: `For security and compliance reasons, each address can only be linked to one account and must be owned by the user. If you believe this address belongs to you, please contact our support team.`,
                warning: `Please only add your own wallet address to receive crypto withdrawals`,
            },
            common: {
                close: `Close`,
            },
            confirm_modal: {
                step: `Step 2 of 3`,
                title: `Complete Information About Your Wallet Address`,
                destination_wallet_address: `Destination Wallet Address`,
                copy_address: `Copy address`,
                copy_success: `Address copied.`,
                copy_failed: `Unable to copy address.`,
                own_wallet_question: `Is this your own wallet address?`,
                own_wallet_yes: `YES, I'm sending to my own wallet address`,
                own_wallet_no: `NO, this wallet or account belongs to another person or entity`,
                wallet_type_question: `Is this address from your private wallet, or from an VASP?`,
                wallet_type_self_hosted: `Self-hosted Wallet`,
                wallet_type_self_hosted_description: `A personal wallet where you control the private keys (e.g. MetaMask, Ledger)`,
                wallet_type_vasp: `Virtual Asset Service Provider`,
                wallet_type_vasp_description: `An exchange account registered in your name (e.g. Binance, Coinbase)`,
                ownership_confirmation: `I confirm this wallet address is owned and controlled by me`,
                continue: `Continue`,
            },
            tr_modal: {
                step: `Step 2 of 3`,
                title: `Complete Information About Your Wallet Address`,
                destination_wallet_address: `Destination Wallet Address`,
                copy_address: `Copy address`,
                copy_success: `Address copied.`,
                copy_failed: `Unable to copy address.`,
                own_wallet_question: `Is this your own wallet address?`,
                own_wallet_yes: `YES, I'm sending to my own wallet address`,
                own_wallet_no: `NO, this wallet address belongs to another person or entity`,
                wallet_type_question: `Is this address from your private wallet, or from an VASP?`,
                wallet_type_self_hosted: `Self-hosted Wallet`,
                wallet_type_self_hosted_description: `A personal wallet where you control the private keys (e.g. MetaMask, Ledger)`,
                wallet_type_vasp: `Virtual Asset Service Provider`,
                wallet_type_vasp_description: `An exchange account registered in your name (e.g. Binance, Coinbase)`,
                wallet_application_name: {
                    label: `Wallet application name`,
                    placeholder: `Wallet application name`,
                },
                self_hosted_truthfulness_notice_before: `Provide information independently and truthfully. If you are following someone’s instructions to provide false information, you are dealing with a `,
                self_hosted_truthfulness_notice_emphasis: `scam!`,
                self_hosted_truthfulness_notice_after: ``,
                wallet_application_screenshot: {
                    label: `Wallet Application Screenshot`,
                    description: `A screenshot showing the wallet app on your own phone, including the wallet interface or the website URL you access your wallet through.`,
                },
                wallet_address_screenshot: {
                    label: `Wallet Address Screenshot`,
                    description: `Show your full wallet address clearly and make sure it is readable. Do not include your recovery phrase or private key.`,
                },
                screenshot_upload: {
                    title: `Upload Your Screenshot`,
                    uploading: `Uploading...`,
                    replace: `Replace screenshot`,
                    remove: `Remove`,
                    invalid_type: `Please upload a PNG or JPG image.`,
                    file_too_large: `Screenshot must be smaller than 10MB.`,
                    failed: `Screenshot upload failed. Please try again.`,
                },
                screenshot_truthfulness_notice: `Both screenshots must be taken by you directly from your own device. Do not use screenshots provided or sent by another person.`,
                ownership_confirmation: `I confirm this wallet address is owned and controlled by me`,
                ownership_confirmation_help: `Control means that only you have access to the wallet’s private key or recovery phrase.`,
                not_supported_title: `This wallet is not supported`,
                not_supported_description: `For security and compliance reasons, withdrawals can only be made to wallets/accounts registered in your own name. Your withdrawal request will be automatically cancel if the wallet address it is not under your name.`,
                continue: `Continue`,
                vasp: {
                    exchange_platform_based: {
                        label: `Where Is This Exchange Platform Based?`,
                        subtitle: `This refers to where the exchange platform is based, not your personal location`,
                        placeholder: `Select platform country...`,
                        other_placeholder: `Enter the platform country...`,
                    },
                },
            },
            high_risk_modal: {
                title: `Address cannot be used`,
                description: `This wallet address did not pass our security and compliance checks.\nFor your protection, please use a wallet address that you own and control.`,
            },
            already_bound_modal: {
                title: `This address is already linked to another account`,
                description: `For security and compliance reasons, each address can only be linked to one account and must be owned by the user. If you believe this address belongs to you, please contact our support team.`,
            },
            address_unavailable_modal: {
                title: `Address Unavailable`,
                line1_before: `This wallet address is considered `,
                line1_highlight: `HIGH RISK`,
                line1_after: ` and cannot be used for withdrawals.`,
                line2: `To protect your account and meet regulatory requirements, please remove this address and use another wallet address under your control.`,
            },
            generic_error_modal: {
                title: `Address cannot be used`,
                description: `This wallet address cannot be used right now.`,
            },
            error_modal: {
                action: `Try A Different Address`,
            },
            security_modal: {
                title: `Security Verification`,
                authenticator_code: `Authenticator Code`,
                authenticator_hint: `Enter the 6-digit code from your authenticator app`,
                password: `Account Password`,
                email_code: `Email Verification Code`,
                resend: `Send Email Verification Code`,
                resend_short: `Send Code`,
                resend_in: `Resend in {n}s`,
                send_success: `Verification code has been sent to your email address.`,
                send_failed: `Too many requests, please try again later.`,
                submit: `Submit`,
                next: `Next`,
                verify_failed: `Verification code is invalid.`,
                save_success: `Token address has been created.`,
            },
        },
        detail: {
            whats_next_title: `What's next?`,
            whats_next_pending_p1: `Your withdrawal request is currently under review.`,
            whats_next_pending_p2: `To minimise potential processing delays, deposits and withdrawals are recommended between 9am and 9pm Australian Eastern Time. Processing times may vary across financial institutions.`,
            whats_next_pending_p3: `If cancellation is required, please contact our support team at the earliest opportunity and quote the relevant Reference ID. Once the withdrawal has been completed, it cannot be reversed.`,
            transaction_notice_title: `Transaction Notice`,
            transaction_notice_p1: `This transaction was created by the platform. It may relate to adjustment of service fee, overpayment or correction of your account transactions in accordance with applicable platform policies. No further action is required.`,
            transaction_notice_p2: `For enquiries regarding this transaction, please contact our support team and quote the relevant Reference ID.`,
            withdraw_to_title: `Withdraw To`,
            nick_name: `Nick Name`,
            token_label: `Token`,
            chain_label: `Chain`,
            address_label: `Address`,
            bank_name_label: `Bank Name`,
            bsb_label: `BSB`,
            account_number_label: `Account Number`,
            account_name_label: `Account Name`,
        },
    },
    kyc: {
        btn_update_now: "Update Now",
        individual_email_title: "Individual Email Address",
        individual_email_hint: "This email is required to complete identity verification including facial verification and to ensure the individual is informed about the company account registration",
        financial_statements_title: "Financial Statements",
        financial_statements_desc: "Financial statements for the most recent financial year. Including balance sheet, profit and loss statement and cash flow statement if available"
    }
}
